// Dados base extraídos da planilha Tabela_Atualizada.xlsx
const DEFAULT_ITEMS = [
  { id: 'fronha',       name: 'Fronha',            locacao: 0.984739,  lavanderia: 1.566265 },
  { id: 'toalha_banho', name: 'Toalha de Banho',   locacao: 2.3751,    lavanderia: 3.240964 },
  { id: 'toalha_rosto', name: 'Toalha de Rosto',   locacao: 0.931727,  lavanderia: 1.60241  },
  { id: 'piso',         name: 'Piso de Banheiro',  locacao: 1.185542,  lavanderia: 1.939759 },
  { id: 'piscina',      name: 'Toalha de Piscina', locacao: 1.882731,  lavanderia: 3.240964 },
  { id: 'manta',        name: 'Manta',             locacao: 3.170281,  lavanderia: 8.421687 },
  { id: 'solteiro',     name: 'Lençol Solteiro',   locacao: 3.738956,  lavanderia: 3.60241  },
  { id: 'queen',        name: 'Lençol Queen',       locacao: 5.661847,  lavanderia: 3.60241  },
  { id: 'king',         name: 'Lençol King',        locacao: 6.26506,   lavanderia: 3.60241  },
  { id: 'superking',    name: 'Lençol Superking',   locacao: 6.440161,  lavanderia: 3.60241  },
];

export default DEFAULT_ITEMS;
